import { ICartDetailModel, IProductModel } from 'components/Cart/models';
import { CART_PRODUCT_IDS } from '../Cart.const';

const filterProducts = (products: IProductModel[], predicate: (plans: any) => boolean): IProductModel[] =>
  products.filter(product => predicate(product.installmentPlans));

export const getCartProductsAndAccessories = (cart: ICartDetailModel) => {
  const allCartProducts = [...(cart?.cartMetadata?.hardware ?? [])];
  const allCartAccessories = [...(cart?.products ?? [])];

  const payInFullCartProducts = filterProducts(
    allCartProducts,
    plans => !plans || !(plans.SL36 || plans.SL48),
  );
  const payMonthlyCartProducts = filterProducts(allCartProducts, plans => plans?.SL36 || plans?.SL48);

  const payInFullCartAccessories = filterProducts(
    allCartAccessories,
    plans => !plans || !(plans.SL36 || plans.SL48),
  );
  const payMonthlyCartAccessories = filterProducts(allCartAccessories, plans => plans?.SL36 || plans?.SL48);

  const payInFullProductsAndAccessories = [...payInFullCartProducts, ...payInFullCartAccessories];
  const payMonthlyProductsAndAccessories = [...payMonthlyCartProducts, ...payMonthlyCartAccessories];
  const allCartProductsAndAccessories = [...allCartProducts, ...allCartAccessories];

  return {
    payInFullCartProducts,
    payInFullCartAccessories,
    payMonthlyCartProducts,
    payMonthlyCartAccessories,
    payInFullProductsAndAccessories,
    payMonthlyProductsAndAccessories,
    allCartProducts,
    allCartAccessories,
    allCartProductsAndAccessories,
  };
};

export const isPayMonthlyAndCartHasProducts = (
  isPayMonthly: boolean,
  products: IProductModel[] | { product: IProductModel }[],
) => {
  return isPayMonthly && products.length > 0;
};

export const transformCartProductsToProductObject = (products: IProductModel[]) => {
  return products.map(product => ({ product })) || [];
};

export const isAccountOnlyCart = (cart: ICartDetailModel) => {
  const { allCartProductsAndAccessories } = getCartProductsAndAccessories(cart);
  return allCartProductsAndAccessories.some(item => item.id === CART_PRODUCT_IDS.NO_HARDWARE);
};
